var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 308 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1552",
    transform: "translate(.001)",
    style: {
      fill: "none"
    },
    d: "M0 0h23.999v23.999H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13413",
    d: "M12 24c9.882 0 12-2.118 12-12S21.882 0 12 0 0 2.118 0 12s2.118 12 12 12zm0-2a26.9 26.9 0 0 0 5.61-.438 5.218 5.218 0 0 0 2.681-1.271 5.218 5.218 0 0 0 1.271-2.681A26.906 26.906 0 0 0 22 12a26.905 26.905 0 0 0-.438-5.61 5.219 5.219 0 0 0-1.271-2.681 5.219 5.219 0 0 0-2.681-1.271A26.905 26.905 0 0 0 12 2a26.906 26.906 0 0 0-5.61.438 5.218 5.218 0 0 0-2.682 1.27 5.218 5.218 0 0 0-1.27 2.682A26.9 26.9 0 0 0 2 12a26.9 26.9 0 0 0 .438 5.61 5.218 5.218 0 0 0 1.271 2.681 5.218 5.218 0 0 0 2.681 1.271A26.9 26.9 0 0 0 12 22z",
    style: {
      fill: "#abafd1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13414",
    d: "M16.462 12.613a1.308 1.308 0 0 1 0 1.849l-5.23 5.23a1.308 1.308 0 0 1-1.849-1.849l4.306-4.306-4.306-4.305a1.308 1.308 0 0 1 1.849-1.849z",
    transform: "translate(-.923 -1.538)",
    style: {
      fill: "#6610f2"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.d05e0852332ec62ddf8a8dad4da6c11c.svg";
export { ForwardRef as ReactComponent };